import { render, staticRenderFns } from "./ModalLuxRuleEdit.vue?vue&type=template&id=752a5cbf&scoped=true"
import script from "./ModalLuxRuleEdit.vue?vue&type=script&lang=js"
export * from "./ModalLuxRuleEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalLuxRuleEdit.vue?vue&type=style&index=0&id=752a5cbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a5cbf",
  null
  
)

export default component.exports